const choices = {
    trade: 'Commerce / Fourniture de logement',
    services: 'Prestations de services',
};

export default choices;
